import {
  DataBlockTableColumnDto,
  DataType,
  DataBlockDictionaryItemDto,
} from '@lmt/shared-types';
import {
  DXG,
  useDataGrid,
} from '@lmt/unicorn-shared/app/common/devexpress/Grid/dx-grid';
import {
  DictionaryColumnDataProvider,
  getDxDataType,
} from '@lmt/unicorn-shared/app/components/editor/components/blocks/Table';
import React, { FC, useEffect, useState } from 'react';

import styles from './MergePair.module.scss';

interface TableProps {
  value: [];
  columns: DataBlockTableColumnDto[];
}

export const CustomFieldTable: FC<TableProps> = (props) => {
  const { value, columns } = props;
  const [columnDictionaryValues, setColumnDictionaryValues] = useState<
    Record<string, DataBlockDictionaryItemDto[]>
  >({});
  const [data, setData] = useState<any[]>();
  useDataGrid();

  useEffect(() => {
    // we should not modify the source 'Value', because it will be sent to backend during Merge
    const clonedValue = JSON.parse(
      JSON.stringify(value),
    ) as TableProps['value'];
    const updatedData = clonedValue.map((row: any, index) => {
      const updatedRow = row;
      columns.forEach((column) => {
        if (
          column.dataType === DataType.Dictionary &&
          column.dictionaryColumnId === null
        ) {
          updatedRow[column.name] =
            (columnDictionaryValues[column.name] ?? []).find(
              (dictionary) => dictionary.id === parseInt(row[column.name]),
            )?.value ?? row[column.name];
        }
      });
      return {
        id: index,
        ...updatedRow,
      };
    });
    setData(updatedData);
  }, [columnDictionaryValues]);

  return (
    <div className={styles.tableContainer}>
      {columns
        .filter((x) => x.dataType === DataType.Dictionary)
        .map((column) => (
          <DictionaryColumnDataProvider
            key={column.name}
            dictionaryId={column.dictionaryId}
            onValuesReceived={(data) => {
              setColumnDictionaryValues((prev) => {
                return {
                  ...prev,
                  [column.name]: data,
                };
              });
            }}
          />
        ))}
      <DXG.DataGrid
        keyExpr={'id'}
        dataSource={data}
        showBorders={true}
        repaintChangesOnly={true}
        style={{ width: '100%' }}
      >
        <DXG.Paging enabled={false} />

        {columns.map((column) => (
          <DXG.Column
            key={column.name}
            dataField={column.name}
            caption={column.name}
            dataType={getDxDataType(column)}
          />
        ))}
      </DXG.DataGrid>
    </div>
  );
};
